import "./pre_firmy.scss"

onReady(() => {
  new Swiper(".swiper-testimonials", {
    direction: "horizontal",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  })
  new Swiper(".swiper-brands", {
    slidesPerView: "auto",
    spaceBetween: 40,
    autoplay: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-brands-button-next",
      prevEl: ".swiper-brands-button-prev",
    },
  })

  const alert = document.querySelector(".alert")
  if (alert) {
    window.scrollTo({
      top: alert.getBoundingClientRect().top + window.pageYOffset - 110,
      behavior: "smooth",
    })
  }
})
